import { defineMessages } from "react-intl";

import {
	resultMessages,
	validator
} from "lib/build/forms/htx/screening-procedures/chestCt";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	chestCt: {
		id: "form.chest_ct.title",
		defaultMessage: "Mellkas CT"
	},
	result: {
		id: "form.chest_ct.result",
		defaultMessage: "Eltérés"
	}
});

const fields: {
	[key: string]: FieldData;
} = {
	result: {
		type: "field",
		path: ["result"],
		label: messages.result,
		errorMessages: genericErrorMessages,
		input: {
			type: "button-group",
			props: { labels: resultMessages }
		}
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.result }] }]
};

export const node: LeafNode = {
	id: "chestCt",
	value: {
		schemaId: "chestCt",
		title: messages.chestCt,
		validator,
		fieldset,
		isImportant: true
	}
};
